import styled from 'styled-components'

export const Wrapper = styled.form`
  margin-top: 48px;
`

export const Header = styled.header`
  display: flex;
  gap: 16px;
  align-items: flex-end;
  flex-wrap: wrap;

  @media (max-width: 1600px) {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 16px;
    grid-row-gap: 16px;

    div:nth-child(3) {
      grid-column: 1 / span 2;
    }
  }
`

export const InputsContainer = styled.div`
  display: block;
  grid-template-columns: repeat(4, 1fr);
  grid-column-gap: 16px;
  grid-row-gap: 16px;
  align-items: end;

  @media (max-width: 1600px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 1280px) {
    grid-template-columns: repeat(1, 1fr);
  }

  section {
    display: flex;
    align-items: center;
  }

  > input:last-child {
    margin-right: 0;
  }
`

export const Units = styled.section`
  margin: 48px 0;

  section {
    margin-top: 18px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-row-gap: 18px;
  }
`

export const Complement = styled.section``

export const Justification = styled.div`
  margin: 48px 0;

  textarea {
    height: 150px;
  }
`

export const Observations = styled.section`
  margin: 48px 0;

  textarea {
    height: 100px;
  }
`

export const ActionsButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  @media (max-width: 1024px) {
    flex-direction: column;
    justify-content: center;
  }
`

export const JustificationLengthMessage = styled.span`
  font-size: ${({ theme }) => theme.font.sizes.small};
  color: ${({ theme }) => theme.colors.lightRed};
  margin-top: 2px;
`

export const InputButtonContainer = styled.div`
  display: flex;
  position: relative;
  justify-content: flex-end;
  align-self: flex-start;

  button {
    position: absolute;
    width: 51px;
    height: 54px;
    display: flex;
    justify-content: center;
    align-content: center;
    margin-left: 10px;
    border-radius: 0px 10px 10px 0px;

    span {
      width: 30px;
      height: 30px;
    }

    svg {
      height: 30px;
      width: 30px;

      path {
        height: 30px;
        width: 30px;
        fill: white;
        opacity: 1;
      }
    }
  }
`
